import { render, staticRenderFns } from "./KoutsuhiKeiroCard.vue?vue&type=template&id=2804d88d&scoped=true&"
import script from "./KoutsuhiKeiroCard.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiKeiroCard.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiKeiroCard.vue?vue&type=style&index=0&id=2804d88d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2804d88d",
  null
  
)

export default component.exports